import { Link } from "react-router"
import { ExternalLink } from "lucide-react"

const productLinks = [
  { name: "Features", to: "/#features" },
  { name: "Pricing", to: "/#pricing" },
  { name: "Demo", to: "/#demo" },
  { name: "FAQ", to: "/#faq" },
]

const legalLinks = [
  { name: "Privacy Policy", to: "/privacy" },
  { name: "Terms of Service", to: "/terms" },
]

export default function HomeFooter() {
  return (
    <footer className="bg-[#0D0D0D] text-white">
      {/* Top accent line */}
      <div className="h-0.75 w-full" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-2 flex flex-col gap-6">
            <img src="/kanu-logo.png" alt="Kanu Energy Logo" className="h-10 w-min brightness-0 invert" />
            <p className="text-sm text-white/45 leading-relaxed max-w-xs">
              Kanu aggregates grid connection data, planning records, and DNO intelligence so energy developers can move faster and with more confidence.
            </p>
          </div>

          {/* Product */}
          <div className="md:col-start-4 flex flex-col gap-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white">Product</h4>
            <ul className="flex flex-col gap-3">
              {productLinks.map(({ name, to }) => (
                <li key={name}>
                  <a href={to} className="text-sm text-white/50 hover:text-white transition-colors duration-150">
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white">Legal</h4>
            <ul className="flex flex-col gap-3">
              {legalLinks.map(({ name, to }) => (
                <li key={name}>
                  <Link to={to} className="text-sm text-white/50 hover:text-white transition-colors duration-150">
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/30">{"© 2026 Kanu Energy. All rights reserved."}</p>
          <div className="flex items-center gap-6">
            <a
              href="https://x.com/kanuenergy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/40 hover:text-white transition-colors duration-150 flex items-center gap-1.5"
            >
              X <ExternalLink className="h-3 w-3" />
            </a>
            <a
              href="https://linkedin.com/company/kanuenergy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/40 hover:text-white transition-colors duration-150 flex items-center gap-1.5"
            >
              LinkedIn <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
